module.exports = new __parcel__URL__("no-results-light.aa2e1109.svg").toString();